function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMasterfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 68 68",
    id: "folder-update",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M64,60.61H4a3,3,0,0,1-3-3V10.39a3,3,0,0,1,3-3H21.13a3,3,0,0,1,2.12.88l5.83,5.84H64a3,3,0,0,1,3,3v40.5A3,3,0,0,1,64,60.61ZM4,9.39a1,1,0,0,0-1,1V57.61a1,1,0,0,0,1,1H64a1,1,0,0,0,1-1V17.11a1,1,0,0,0-1-1H28.67a1,1,0,0,1-.71-.29L21.84,9.68a1.05,1.05,0,0,0-.71-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M52 54.61H16a1 1 0 0 1 0-2H52a1 1 0 0 1 0 2zM36.08 49.77H31.92a1 1 0 0 1-.94-.66l-.71-2-.77-.32L28 46.18l-1.9.91A1 1 0 0 1 25 46.9c-1.49-1.47-1.49-1.47-3-3a1 1 0 0 1-.19-1.14l.91-1.9c-.23-.54-.41-1-.6-1.44l-.33-.79-2-.71a1 1 0 0 1-.66-.94V32.86a1 1 0 0 1 .66-.94l2-.71.33-.8c.19-.47.37-.89.6-1.43l-.92-1.92a1 1 0 0 1 .2-1.14L25 23a1 1 0 0 1 1.14-.19l1.9.91 1.44-.6.79-.33.71-2a1 1 0 0 1 .94-.66h4.16a1 1 0 0 1 .94.66l.72 2 .77.32L40 23.7l1.9-.91A1 1 0 0 1 43 23l3 2.94a1 1 0 0 1 .2 1.14L45.24 29l.59 1.4.34.83 2 .71a1 1 0 0 1 .66.94V37a1 1 0 0 1-.66.94l-2 .71-.34.82-.59 1.41.91 1.9A1 1 0 0 1 46 43.94c-1.47 1.49-1.47 1.49-3 3a1 1 0 0 1-1.14.19L40 46.18l-1.47.61-.75.32-.72 2A1 1 0 0 1 36.08 49.77zm-3.46-2h2.76L36 46a1 1 0 0 1 .56-.58L37.72 45l1.87-.79a1 1 0 0 1 .82 0l1.68.81c.86-.85 1.11-1.1 2-2l-.81-1.68a1 1 0 0 1 0-.82c.32-.73.53-1.24.76-1.81l.52-1.23a1 1 0 0 1 .58-.55l1.75-.62V33.56l-1.75-.62a1 1 0 0 1-.58-.55L44 31.15c-.23-.56-.45-1.07-.76-1.8a1 1 0 0 1 0-.82l.81-1.69-2-1.95-1.68.81a1 1 0 0 1-.82 0l-1.85-.78-1.18-.49a1 1 0 0 1-.56-.59l-.62-1.75H32.62L32 23.86a1 1 0 0 1-.55.59l-1.2.49-1.84.78a1 1 0 0 1-.82 0l-1.68-.81-2 1.95.81 1.69a1 1 0 0 1 0 .82L24 31.18l-.51 1.21a1 1 0 0 1-.58.55l-1.75.62v2.76l1.75.62a1 1 0 0 1 .58.55l.5 1.2.77 1.84a1 1 0 0 1 0 .82L24 43l2 2 1.68-.81a1 1 0 0 1 .82 0c.75.33 1.28.54 1.86.79l1.18.49A1 1 0 0 1 32 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M34,41.18A6.24,6.24,0,1,1,39.49,32a1,1,0,0,1-1.76,1,4.24,4.24,0,1,0,.41,2.91,1,1,0,0,1,1.19-.76,1,1,0,0,1,.76,1.19A6.27,6.27,0,0,1,34,41.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M38.6,33.45H35.77a1,1,0,0,1,0-2H37.6V29.62a1,1,0,1,1,2,0v2.83A1,1,0,0,1,38.6,33.45Z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMasterfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-masterfile.e5c6fe5c6926b3dc3e658ec982174c36.svg";